export const WHATSAPP_NUMBER = '201064307053';

export const PHONE_DISPLAY = '+20 10 6430 7053';
export const PHONE_TEL = 'tel:+201064307053';

export const EMAIL = 'laithymohamed9@gmail.com';
export const EMAIL_MAILTO = 'mailto:laithymohamed9@gmail.com';

export const ADDRESS = {
  area: 'Al-Abasiry, Beni Suef',
  street: 'Chanel St., off Abdelsalam Aref St., next to Dona Dony dealership',
};

export const MAP_URL =
  'https://www.bing.com/maps/search?q=%D8%A7%D9%84%D8%A7%D8%A8%D8%A7%D8%B5%D9%8A%D8%B1%D9%89%2C+Bani+Suwayf%2C+Egypt%2C+082&cp=29.075300%7E31.098250&lvl=15.2';

export const SOCIAL_LINKS = {
  facebook: 'https://www.facebook.com/share/18zvHzXSpz/',
  instagram: 'https://www.instagram.com/lithioo_for_perfumes',
};

export const WHATSAPP_GREETING = 'Hello! I would like to know more about Lithioo Perfumes products.';
